import React, { Fragment } from 'react'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'

import withGeneralTranslations from '../hocs/withGeneralTranslations'

import Navigation from '../layouts/Navigation'
import IntroSection from '../components/IntroSection'

const styles = theme => ({
  containerStyle: {
    flex: '1 0 auto'
  }
})

const Disclaimer = ({ generalTranslations, classes: { containerStyle } }) => (
  <Fragment>
    <Navigation enableOverviewShortcuts={false} />
    <div className={containerStyle}>
      <IntroSection
        kicker=""
        title=""
        headline="Disclaimer"
        description={generalTranslations('disclaimer')}
      />
    </div>
  </Fragment>
)

export default compose(
  withGeneralTranslations,
  withStyles(styles)
)(Disclaimer)



// WEBPACK FOOTER //
// ./src/screens/Disclaimer.js